import axios from "axios";
import FeatherIcon from "feather-icons-react";
import React, { Component } from "react";
import { toast } from "react-toastify";

class Sms extends Component {
    state = {
        sms: [], loading: true, loadError: false, search: "", currentPage: 1,
        pageSize: 20, sendingId: null, deletingId: null
    };

    _isMounted = false;

    componentDidMount() { this._isMounted = true; this.getSms(); }
    componentWillUnmount() { this._isMounted = false; }

    getSms = async () => {
        this.setState({ loading: true, loadError: false });
        try {
            const response = await axios.get("sms");
            const sms = response.status === 200 && Array.isArray(response.data) ? response.data : [];
            if (this._isMounted) this.setState({ sms, loading: false });
        } catch (error) {
            if (this._isMounted) this.setState({ loading: false, loadError: true });
        }
    };

    handleMessageChange = (smsId, message) => {
        this.setState(({ sms }) => ({
            sms: sms.map((item) => item.id === smsId ? { ...item, message } : item)
        }));
    };

    storeSms = async (smsId, message) => {
        const editedMessage = String(message || "").trim();
        if (!editedMessage || this.state.sendingId !== null || this.state.deletingId !== null) return;
        this.setState({ sendingId: smsId });
        try {
            const response = await axios.post("sms", { id: smsId, message: editedMessage });
            await this.getSms();
            toast.success(response?.data?.msg || "Le SMS a été envoyé.");
        } catch (error) {
            toast.error(error?.response?.data?.msg || "L'envoi du SMS a échoué.");
        } finally {
            if (this._isMounted) this.setState({ sendingId: null });
        }
    };

    delete = async (smsId) => {
        // if (!window.confirm("Annuler ce SMS en attente ?")) return;
        this.setState({ deletingId: smsId });
        try {
            const response = await axios.delete("sms/" + smsId);
            await this.getSms();
            toast.success(response?.data?.msg || "Le SMS a été annulé.");
        } catch (error) {
            toast.error(error?.response?.data?.msg || "L'annulation a échoué.");
        } finally {
            if (this._isMounted) this.setState({ deletingId: null });
        }
    };

    getName = (user = {}) => [user.last_name, user.first_name].filter(Boolean).join(" ") || "Destinataire";
    getInitials = (user = {}) => [user.last_name, user.first_name].filter(Boolean).map((name) => name.charAt(0)).join("").slice(0, 2).toUpperCase() || "SMS";

    getFilteredSms = () => {
        const term = this.state.search.trim().toLowerCase();
        if (!term) return this.state.sms;
        return this.state.sms.filter((item) => {
            const user = item.user || {};
            return [item.id, item.message, this.getName(user), user.tel, user.email]
                .some((value) => String(value || "").toLowerCase().includes(term));
        });
    };

    changePage = (page, totalPages) => this.setState({ currentPage: Math.max(1, Math.min(page, totalPages)) });

    getPageNumbers = (currentPage, totalPages) => {
        const start = Math.max(1, Math.min(currentPage - 1, totalPages - 2));
        return Array.from({ length: Math.min(3, totalPages) }, (_, index) => start + index);
    };

    render() {
        const { sms, loading, loadError, search, currentPage, pageSize, sendingId, deletingId } = this.state;
        const filteredSms = this.getFilteredSms();
        const totalPages = Math.max(1, Math.ceil(filteredSms.length / pageSize));
        const safePage = Math.min(currentPage, totalPages);
        const pageItems = filteredSms.slice((safePage - 1) * pageSize, safePage * pageSize);
        const from = filteredSms.length ? (safePage - 1) * pageSize + 1 : 0;
        const to = Math.min(safePage * pageSize, filteredSms.length);
        const actionPending = sendingId !== null || deletingId !== null;

        return (
            <section className="staff-panel mt-3 mb-0">
                <div className="staff-toolbar">
                    <div><span><FeatherIcon icon="message-square" size="14" /> Centre SMS</span><h2>Messages en attente</h2></div>
                    <label>
                        <FeatherIcon icon="search" size="16" />
                        <input type="search" value={search} placeholder="Nom, numéro ou message..." aria-label="Rechercher dans les SMS" onChange={(event) => this.setState({ search: event.target.value, currentPage: 1 })} />
                        {search && <button type="button" onClick={() => this.setState({ search: "", currentPage: 1 })} title="Effacer la recherche"><FeatherIcon icon="x" size="14" /></button>}
                    </label>
                    <select className="form-select form-select-sm w-auto" value={pageSize} aria-label="Messages par page" onChange={(event) => this.setState({ pageSize: Number(event.target.value), currentPage: 1 })}>
                        <option value="20">20 par page</option><option value="50">50 par page</option><option value="100">100 par page</option>
                    </select>
                    <button type="button" className="btn btn-sm btn-light" onClick={this.getSms} disabled={loading || actionPending} title="Actualiser">
                        <FeatherIcon className={loading ? "reminds-spin" : ""} icon="refresh-cw" size="15" />
                    </button>
                </div>

                {!loading && !loadError && (
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <small className="text-muted">{filteredSms.length} message{filteredSms.length > 1 ? "s" : ""}{search ? ` trouvé${filteredSms.length > 1 ? "s" : ""} sur ${sms.length}` : " en attente"}</small>
                        <span className="staff-table-matricule">Modification directe</span>
                    </div>
                )}

                {loading && <div className="reminds-state"><FeatherIcon className="reminds-spin" icon="loader" /><p>Chargement des SMS en attente...</p></div>}
                {!loading && loadError && <div className="reminds-state error"><FeatherIcon icon="alert-circle" /><h3>File d'envoi indisponible</h3><p>Impossible de récupérer les SMS pour le moment.</p><button type="button" onClick={this.getSms}>Réessayer</button></div>}
                {!loading && !loadError && sms.length === 0 && <div className="reminds-state"><FeatherIcon icon="check-circle" /><h3>Aucun SMS en attente</h3><p>La file d'envoi est à jour.</p></div>}
                {!loading && !loadError && sms.length > 0 && filteredSms.length === 0 && <div className="reminds-state"><FeatherIcon icon="search" /><h3>Aucun résultat</h3><p>Essayez avec un autre nom, numéro ou mot-clé.</p><button type="button" onClick={() => this.setState({ search: "", currentPage: 1 })}>Effacer la recherche</button></div>}

                {!loading && !loadError && pageItems.length > 0 && (
                    <div className="table-responsive border rounded">
                        <table className="table table-hover align-middle mb-0">
                            <thead><tr><th scope="col">Destinataire</th><th scope="col">Message à envoyer</th><th scope="col" className="text-end">Actions</th></tr></thead>
                            <tbody>
                                {pageItems.map((item) => {
                                    const user = item.user || {};
                                    const isSending = sendingId === item.id;
                                    const isDeleting = deletingId === item.id;
                                    const message = item.message || "";
                                    return (
                                        <tr key={item.id}>
                                            <td style={{ width : '30%' }}>
                                                <div className="staff-table-person">
                                                    <span className="staff-table-avatar">{user.avatar ? <img src={user.avatar} alt="" /> : <i>{this.getInitials(user)}</i>}</span>
                                                    <span><b>{this.getName(user)}</b><small>{user.tel || user.email || "Coordonnées non renseignées"}</small></span>
                                                </div>
                                            </td>
                                            <td style={{ width : '60%' }}>
                                                <form className="reminds-composer" style={{ padding : 0, margin : 0}} >

                                                <textarea style={{ minHeight:35}} rows="2" value={message} maxLength="160" disabled={actionPending} aria-label={`Message pour ${this.getName(user)}`} onChange={(event) => this.handleMessageChange(item.id, event.target.value)} />
                                                </form>
                                                {/* <small className="d-block text-end text-muted mt-1">{message.length}/1000 caractères</small> */}
                                            </td>
                                            <td style={{ width : '10%' }}>
                                                <div className="d-flex justify-content-end gap-2">
                                                    <button type="button" className="btn btn-sm btn-primary d-flex align-items-center gap-1" onClick={() => this.storeSms(item.id, message)} disabled={actionPending || !message.trim()}>
                                                        <FeatherIcon className={isSending ? "reminds-spin" : ""} icon={isSending ? "loader" : "send"} size="14" /> {isSending ? "Envoi..." : "Envoyer"}
                                                    </button>
                                                    <button type="button" className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1" onClick={() => this.delete(item.id)} disabled={actionPending}>
                                                        <FeatherIcon className={isDeleting ? "reminds-spin" : ""} icon={isDeleting ? "loader" : "trash-2"} size="14" /> Annuler
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                {!loading && !loadError && filteredSms.length > 0 && (
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 pt-3">
                        <small className="text-muted">Affichage de {from} à {to} sur {filteredSms.length}</small>
                        <nav aria-label="Pagination des SMS">
                            <ul className="pagination pagination-sm mb-0">
                                <li className={`page-item ${safePage === 1 ? "disabled" : ""}`}><button type="button" className="page-link" onClick={() => this.changePage(safePage - 1, totalPages)}><FeatherIcon icon="chevron-left" size="14" /></button></li>
                                {this.getPageNumbers(safePage, totalPages).map((page) => <li className={`page-item ${page === safePage ? "active" : ""}`} key={page}><button type="button" className="page-link" onClick={() => this.changePage(page, totalPages)}>{page}</button></li>)}
                                <li className={`page-item ${safePage === totalPages ? "disabled" : ""}`}><button type="button" className="page-link" onClick={() => this.changePage(safePage + 1, totalPages)}><FeatherIcon icon="chevron-right" size="14" /></button></li>
                            </ul>
                        </nav>
                    </div>
                )}
            </section>
        );
    }
}

export default Sms;
